import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Card,
  Alert,
} from "@themesberg/react-bootstrap";
import { useHistory } from "react-router-dom";
import { Routes } from "../routes";
import { useAuth } from "../contexts/AuthContext";
import CustomGoogleLogin from "../components/CustomGoogleLogin";
import ErrorToast from "../components/ErrorToast";
import AuthModule from "../core/modules/AuthModule";
import "../scss/login.scss";
import "../scss/google-override.scss";
import "../scss/error-toast.scss";

export default () => {
  const history = useHistory();
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setPageLoaded(true);
    }, 1000);
    
    return () => clearTimeout(timer);
  }, []);

  const handleGoogleSuccess = async (credentialResponse) => {
    setLoading(true);
    setError("");

    // Timeout para evitar que el loading se quede colgado
    const timeoutId = setTimeout(() => {
      setLoading(false);
      setError("La autenticación está tardando demasiado. Intenta nuevamente.");
    }, 30000); // 30 segundos

    try {
      const result = await AuthModule.login(credentialResponse);
      clearTimeout(timeoutId);
      
      if (result.success) {
        // Pasar datos de Google para refresh token si están disponibles
        const googleData = {
          access_token: credentialResponse.access_token,
          credential: credentialResponse.credential
        };
        
        login(
          result.userData, 
          result.token, 
          googleData,
          credentialResponse.refresh_token // Si Google lo proporciona
        );
        
        history.push(Routes.Dashboard.path);
      } else {
        const errorMsg = result.error || "Usuario no autorizado para acceder al sistema";
        setError(errorMsg);
        setShowErrorToast(true);
      }
    } catch (err) {
      clearTimeout(timeoutId);
      console.error('Login error:', err);
      
      // Manejo específico de errores
      let errorMessage = "Error de conexión. Intenta nuevamente.";
      
      if (err.message) {
        if (err.message.includes('fetch') || err.message.includes('network')) {
          errorMessage = "No se pudo conectar al servidor. Verifica tu conexión a internet.";
        } else if (err.message.includes('timeout')) {
          errorMessage = "La conexión está tardando demasiado. Intenta nuevamente.";
        } else {
          errorMessage = err.message;
        }
      }
      
      setError(errorMessage);
      setShowErrorToast(true);
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleError = (error) => {
    console.error('Google OAuth error:', error);
    
    let errorMessage = "Error en la autenticación con Google";
    
    // Manejo específico de errores de Google OAuth
    if (error) {
      if (error.error === 'popup_closed_by_user') {
        errorMessage = "Autenticación cancelada por el usuario";
      } else if (error.error === 'access_denied') {
        errorMessage = "Acceso denegado. Debes autorizar el acceso para continuar";
      } else if (error.error === 'popup_blocked') {
        errorMessage = "Popup bloqueado. Permite popups para este sitio";
      }
    }
    
    setError(errorMessage);
    setShowErrorToast(true);
  };

  return (
    <div className="login-container">
      <Row className="g-0 h-100">
        {/* Banner lateral */}
        <Col lg={7} className="d-none d-lg-block">
          <div className="login-banner"></div>
        </Col>

        {/* Formulario de login */}
        <Col lg={5} xs={12}>
          <div className="login-form-container">
            <Card className="login-card">
              <div className="login-header">
                <div className="logo">
                  <img src="/nuevologoIUD.png" alt="Logo IUD" />
                </div>
                <h1>Control de Asistencia</h1>
                <p>Inicia sesión para acceder al sistema</p>
              </div>

              <ErrorToast
                show={showErrorToast}
                onClose={() => {
                  setShowErrorToast(false);
                  setError("");
                }}
                title="Error de Autenticación"
                message={error}
              />

              {loading && (
                <div className="loading-spinner">
                  <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                  <span className="spinner-text">Validando usuario...</span>
                </div>
              )}

              <div className="google-login-container">
                <CustomGoogleLogin
                  onSuccess={handleGoogleSuccess}
                  onError={handleGoogleError}
                  loading={loading}
                />
              </div>

              <div className="login-footer">
                <p>Solo empleados autorizados pueden acceder al sistema</p>
              </div>
            </Card>
          </div>
        </Col>
      </Row>
      
      {/* Footer fijo que se sobrepone - solo cuando la página haya cargado */}
      {pageLoaded && (
        <div className="login-footer-overlay">
          <img src="/LOGOS---IUD.png" alt="Logos IUD" />
        </div>
      )}
    </div>
  );
};
